// extracted by mini-css-extract-plugin
export var divider = "_n3-0";
export var systemMessage = "_n3-1";